import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import vuetify from './plugins/vuetify';
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css'
Vue.config.productionTip = false
Vue.use(ElementUI);
new Vue({
  i18n,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
